export const getLabel = (text: string) => text.toLocaleLowerCase().trim().replaceAll(' ', '-');
